import React from 'react';
import { OrderItem } from '../../types/order';
import { formatPrice } from '../../utils/utility';

interface OrderItemsProps {
  items: OrderItem[];
}

const OrderItems: React.FC<OrderItemsProps> = ({ items }) => {
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Order Items</h2>
      </div>
      <div className="divide-y divide-gray-200">
        {items.map((item) => (
          <div key={item._id} className="px-6 py-4">
            <div className="flex items-center space-x-4">
              <img
                src={item.images[0] || '/placeholder-product.png'}
                alt={item.title}
                className="w-16 h-16 object-cover rounded-md"
              />
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-gray-900 break-words">{item.title}</h3>
                <p className="text-sm text-gray-500">Qty: {item.quantity}</p>
                {item.attributes && Object.keys(item.attributes).length > 0 && (
                  <div className="mt-1">
                    {Object.entries(item.attributes).map(([key, value]) => (
                      <span key={key} className="inline-block bg-gray-100 rounded-full px-2 py-1 text-xs text-gray-600 mr-2 mb-1">
                        {key}: {value}
                      </span>
                    ))}
                  </div>
                )}
                {item.discountPercent > 0 && (
                  <div className="mt-1">
                    <span className="text-xs text-green-600 font-medium">
                      {item.discountPercent}% off
                    </span>
                  </div>
                )}
              </div>
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{formatPrice(item.discountedPrice * item.quantity)}</p>
                <p className="text-sm text-gray-500 line-through">{formatPrice(item.mrp * item.quantity)}</p>
                <p className="text-xs text-green-600">Save {formatPrice(item.discount * item.quantity)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderItems;
